function Adicao(id,quantidade,ordemId,materiaPrimaId,unidade,nomeMp,quantidadeRealizada,status) {
    this.id = id
    this.quantidade = quantidade
    this.ordemId = ordemId
    this.materiaPrimaId = materiaPrimaId
    this.unidade = unidade
    this.nomeMp = nomeMp
    this.quantidadeRealizada = quantidadeRealizada
    this.status = status
}

export default Adicao